/**
 * Client-safe image proxy for social CDN thumbnails.
 *
 * Raw Instagram/Facebook CDN URLs (`*.cdninstagram.com`, `*.fbcdn.net`, `scontent*`)
 * are signed + referer-protected, so they 403 or expire when loaded cross-origin in a
 * browser `<img>`. Routing them through Outfame's Cloudflare edge worker
 * (`/ig-assets/?url=...`) fetches the bytes server-side and serves them reliably.
 *
 * This mirrors `Instagram.getProxiedImageUrl()` but is a standalone ~10-line helper so
 * client components don't pull the heavy `@shared-libs/instagram` provider barrel into
 * the browser bundle. Non-Instagram URLs (TikTok CDN, local `/img/...`, already-proxied)
 * pass through unchanged.
 */

const IG_EDGE_PROXY_URL = "https://www.outfame.com/ig-assets/"

export function proxyImageUrl(url: string | null | undefined): string {
    if (!url || !url.includes("http")) return url || ""

    // Already proxied (edge worker or the dev workers.dev origin) — leave as-is.
    if (url.includes("/ig-assets") || url.includes("/api/ig-proxy") || url.includes("workers.dev")) {
        return url
    }

    const isInstagramCdn =
        url.includes("cdninstagram.com") ||
        url.includes("fbcdn.net") ||
        url.includes("scontent")

    if (!isInstagramCdn) return url

    return `${IG_EDGE_PROXY_URL}?url=${encodeURIComponent(url)}`
}
